<template>
    <div class="template-container">
        <nav class="add-navigation flex flex-wrap">
            <div
                    @click="$router.push({ name: 'company-admin-templates-list' })"
                    class="back-link "
            >
                <svg
                        class="icon"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        version="1.1"
                >
                    <path
                            d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
                            id="path-1"
                    />
                </svg>
                <p class="white_space">Back to Template Listing</p>
            </div>
            <div class="buttons-wrapper flex-wrap">
                <div
                        @click="$router.push({ name: 'company-admin-templates-list' })"
                        class="secondary-button my-2 my-sm-0"
                >
                    <secondary-button>Cancel</secondary-button>
                </div>
                <div class="primary-button my-2 my-sm-0">
                    <primary-button @click.native="addtemplate"
                    >Add Template
                    </primary-button
                    >
                </div>
            </div>
        </nav>
        <div class="add-container">
            <div class="container-wrapper p-2 ">
                <primary-input
                        type="text"
                        name="template"
                        class="field"
                        :value="template.template_name"
                        @input="handleTemplateNameChange"
                        v-validate="'required'"
                        :class="{ input: true, 'is-danger': errors.has('template') }"
                        placeholder="Type a name of Template"
                />
                <div class="help is-danger" v-if="errors.has('template')">
                    {{ errors.first("template") }}
                </div>
                <div class="help is-danger" v-if="contactError">
                    {{ contactError.template ? contactError.template[0] : null }}
                </div>

                <text-area
                        placeholder="Enter sms text"
                        :value="template.sms_text"
                        @input="handleSmsTextChange"
                        maxlength="160"
                        class="sms_text field"
                        ref="sms_text"
                        name="sms text"
                />
                <label>
                    Available tags:
                    <span @click="addTag('name')" style="cursor: pointer">{name}</span>
                    <span @click="addTag('url')" style="margin-left: 5px; cursor: pointer"
                    >{url}</span
                    >
                    <span
                            @click="addTag('code')"
                            style="margin-left: 5px; cursor: pointer"
                    >{code}</span
                    >
                    <span
                            @click="addTag('string')"
                            style="margin-left: 5px; cursor: pointer"
                    >{string}</span
                    >
                </label>

                <div class="help is-danger" v-if="errors.has('sms text')">
                    {{ errors.first("sms text") }}
                </div>
                <div class="help is-danger" v-if="contactError">
                    {{ contactError.sms_text ? contactError.sms_text[0] : null }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
            PrimaryInput: () => import("@/components/Inputs/PrimaryInput.vue"),
            PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
            SecondaryButton: () => import("@/components/Buttons/SecondaryButton.vue"),
            PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
            TextArea: () => import("@/components/Inputs/TextArea.vue"),
        },
        data: () => ({
            contactError: null,
            template: {
                template_name: null,
                sms_text: "",
                company_uuid: null,
            },
        }),
        created() {
        },
        methods: {
            handleTemplateNameChange(v) {
                this.template.template_name = this.$capitalize(v);
            },
            handleSmsTextChange(v) {
                this.template.sms_text = v; //this.$capitalize(v);
            },
            addTag(type) {
                // Used to append text on cursor position
                // Only working else part
                let myField = this.$refs["sms_text"];
                //IE support
                if (document.selection) {
                    myField.focus();
                    sel = document.selection.createRange();
                    sel.text = "{" + type + "}";
                }
                //MOZILLA and others
                else if (myField.selectionStart || myField.selectionStart == "0") {
                    var startPos = myField.selectionStart;
                    var endPos = myField.selectionEnd;
                    this.template.sms_text =
                        this.template.sms_text.substring(0, startPos) +
                        "{" +
                        type +
                        "}" +
                        this.template.sms_text.substring(
                            endPos,
                            this.template.sms_text.length
                        );
                } else {
                    this.template.sms_text += "{" + type + "}";
                }
            },
            addtemplate() {
                this.$validator.validate().then((result) => {
                    if (result) {

                        this.$store
                            .dispatch("GetUsers", {per_page: 1000, companyId: this.template.company_uuid})
                            .then((res) => {
                                this.template.company_uuid = res.items[0].company_uuid;
                            })

                        // this.template.company_uuid = this.$store.state.company.company.company_uuid;

                        this.$store
                            .dispatch("AddTemplate", {
                                template: this.template,
                            })
                            .then(() => {
                                this.$snotify.success("The template has been added successfully.", {
                                    timeout: 6000,
                                });

                                this.$router.push({name: "company-admin-templates-list"});
                            })
                            .catch((err) => {
                                if (err.errors) {
                                    this.contactError = err.errors[0].template
                                        ? err.errors[0].template
                                        : null;
                                    setTimeout(() => {
                                        this.contactError = null;
                                    }, 6000);
                                } else {
                                    console.log("err.errors[0]", err.response.data.errors[0]);
                                    this.$snotify.error(
                                        err.response.data.errors[0].template_name.toString(),
                                        {
                                            timeout: 6000,
                                        }
                                    );
                                }
                            });
                    }
                });
            },
        },
    };
</script>

<style lang="scss" scoped>
    .template-container {
        font-family: "Helvetica Neue";
        padding: 0 20px;

        .add-navigation {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            margin-top: 20px;

            .back-link {
                cursor: pointer;
                display: flex;
                align-items: center;
                fill: #51a3f3;
                color: #51a3f3;
                font-family: "Helvetica Neue";
                font-size: 16px;
                font-weight: 500;
                line-height: 20px;

                .icon {
                    margin-right: 5px;
                }

                p {
                    margin-bottom: 0;
                }
            }

            .buttons-wrapper {
                display: flex;
                align-items: center;
                width: fit-sms_text;

                .primary-button {
                    height: 40px;
                    width: 145px;
                }

                .secondary-button {
                    height: 40px;
                    width: 90px;
                    margin-right: 15px;
                }
            }
        }

        .add-container {
            flex-direction: column;
            align-items: center;
            // height: 221px;
            width: 100%;
            font-family: "Helvetica Neue";

            .container-wrapper {
                width: 100%;

                .field {
                    margin-top: 10px;
                    margin-bottom: 15px;
                }
            }

            .email-input {
                margin-bottom: 20px;
            }

            .password-input {
                margin-bottom: 30px;
            }

            .first {
                margin-bottom: 30px;

                .remember-me {
                    display: flex;
                    align-items: center;

                    input {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
    @media (max-width: 349px ) {

      .secondary-button{
        min-width: 145px ;
      }

    }
</style>

